import React from "react";
import { classSelectors } from "../../../../hooks/selectors";
import { getImageUrl } from "../../../../commons/assets_path";

interface Props {
  value: { id?: number; display_name: string; test_value?: string; icon_path?: string };
  index: number;
  readOnly: boolean;
  remove: (i: number) => void;
}

export function Tag(props: Props) {
  const remove = () => props.remove(props.index);
  const { value, readOnly } = props;

  const tagRemoveClass = !readOnly
    ? classSelectors.tagRemove
    : `${classSelectors.tagRemove} ${classSelectors.tagRemoveReadOnly}`;

  return (
    <div className={classSelectors.tag}>
      {value?.icon_path && <img src={getImageUrl(value?.icon_path)} alt="" width={20} height={20} />}
      <div className={classSelectors.tagContent} style={{ padding: 0 }}>
        {value.display_name}
      </div>
      {value?.test_value && (
        <p
          style={{
            fontSize: "12px",
            color: "#777",
            margin: 0,
          }}
        >
          {value.test_value}
        </p>
      )}
      <div className={tagRemoveClass} onClick={remove}>
        <img src={getImageUrl("images/icons/grayCancel.svg")} width="16" height="16" />
      </div>
    </div>
  );
}
